import Entry2FAVerification from './Entry2FAVerification';

export default Entry2FAVerification;
